export const API_ENDPOINTS = {
	auth: {
		login: "/admin/v1/auth/login",
		samlLogin: "/admin/auth/saml/login",
		samlExchange: "/admin/auth/saml/exchange",
		logout: "/admin/v1/auth/logout",
		me: "/admin/v1/auth/me",
		refresh: "/admin/v1/auth/refresh-token",
	},
	events: {
		list: "/admin/v1/events",
		detail: (eventId: string) => `/admin/v1/events/${eventId}`,
		cancel: (eventId: string) => `/admin/v1/events/${eventId}/cancel`,
		publish: (eventId: string) => `/admin/v1/events/${eventId}/publish`,
		attendees: (eventId: string) =>
			`/admin/v1/events/${eventId}/registered-attendees`,
	},
	eventTypes: {
		list: "/admin/v1/event-types",
	},
	properties: {
		list: "/admin/v1/properties",
		locations: "/admin/v1/properties/locations",
		features: "/admin/v1/properties/features",
		detail: (propertyId: string) => `/admin/v1/properties/${propertyId}/detail`,
		units: (propertyId: string) => `/admin/v1/properties/${propertyId}/units`,
		unitDetail: (propertyId: string, unitId: string) =>
			`/admin/v1/properties/${propertyId}/units/${unitId}`,
		configuration: (propertyId: string) =>
			`/admin/v1/properties/${propertyId}/configuration`,
		image: (propertyId: string) => `/admin/v1/properties/${propertyId}/image`,
		exploreScreenElements: "/admin/v1/properties/explore-screen/elements",
		exploreScreen: (propertyId: string) =>
			`/admin/v1/properties/${propertyId}/explore-screen`,
		homeScreenElements: "/admin/v1/properties/home-screen/elements",
		homeScreen: (propertyId: string) =>
			`/admin/v1/properties/${propertyId}/home-screen`,
		paymentConfigurations: (propertyId: string) =>
			`/admin/v1/properties/${propertyId}/payment-configurations`,
		chargeConfiguration: (propertyId: string) =>
			`/admin/v1/properties/${propertyId}/charge-configuration`,
		chargeManagement: "/admin/v1/properties/charge-management",
		chargesServicePeriodSampleXls:
			"/admin/v1/properties/charges-service-periods/sample-xls",
		chargesServicePeriods: (propertyId: string) =>
			`/admin/v1/properties/${propertyId}/charges-service-periods`,
		publishChargesServicePeriod: (propertyId: string, periodId: string) =>
			`/admin/v1/properties/${propertyId}/charges-service-periods/${periodId}/publish`,
		uploadChargesServicePeriod: (propertyId: string, periodId: string) =>
			`/admin/v1/properties/${propertyId}/charges-service-periods/${periodId}/upload`,
		chargesServicePeriodUnits: (propertyId: string, periodId: string) =>
			`/admin/v1/properties/${propertyId}/charges-service-periods/${periodId}/units`,
		exportChargesServicePeriodUnits: (propertyId: string, periodId: string) =>
			`/admin/v1/properties/${propertyId}/charges-service-periods/${periodId}/units/export`,
		chargesServicePeriodUnit: (
			propertyId: string,
			periodId: string,
			unitId: string,
		) =>
			`/admin/v1/properties/${propertyId}/charges-service-periods/${periodId}/units/${unitId}`,
		exportChargesServicePeriodUnit: (
			propertyId: string,
			periodId: string,
			unitId: string,
		) =>
			`/admin/v1/properties/${propertyId}/charges-service-periods/${periodId}/units/${unitId}/export`,
		chargesServicePeriodUnitInvoice: (
			propertyId: string,
			periodId: string,
			unitId: string,
		) =>
			`/admin/v1/properties/${propertyId}/charges-service-periods/${periodId}/units/${unitId}/invoice`,
		revenueConfiguration: (propertyId: string) =>
			`/admin/v1/properties/${propertyId}/revenue-configuration`,
		revenueManagement: "/admin/v1/properties/revenue-management",
		revenueServicePeriodSampleXls:
			"/admin/v1/properties/revenue-service-periods/sample-xls",
		revenueServicePeriods: (propertyId: string) =>
			`/admin/v1/properties/${propertyId}/revenue-service-periods`,
		publishRevenueServicePeriod: (propertyId: string, periodId: string) =>
			`/admin/v1/properties/${propertyId}/revenue-service-periods/${periodId}/publish`,
		revenueServicePeriodUnits: (propertyId: string, periodId: string) =>
			`/admin/v1/properties/${propertyId}/revenue-service-periods/${periodId}/units`,
		exportRevenueServicePeriodUnits: (propertyId: string, periodId: string) =>
			`/admin/v1/properties/${propertyId}/revenue-service-periods/${periodId}/units/export`,
		uploadRevenueServicePeriodUnits: (propertyId: string, periodId: string) =>
			`/admin/v1/properties/${propertyId}/revenue-service-periods/${periodId}/units/upload`,
		revenueServicePeriodUnit: (
			propertyId: string,
			periodId: string,
			unitId: string,
		) =>
			`/admin/v1/properties/${propertyId}/revenue-service-periods/${periodId}/units/${unitId}`,
		exportRevenueServicePeriodUnit: (
			propertyId: string,
			periodId: string,
			unitId: string,
		) =>
			`/admin/v1/properties/${propertyId}/revenue-service-periods/${periodId}/units/${unitId}/export`,
		revenueServicePeriodUnitStatement: (
			propertyId: string,
			periodId: string,
			unitId: string,
		) =>
			`/admin/v1/properties/${propertyId}/revenue-service-periods/${periodId}/units/${unitId}/statement`,
		monthlyStatementConfiguration: (propertyId: string) =>
			`/admin/v1/properties/${propertyId}/monthly-statement-configuration`,
		monthlyStatementManagement:
			"/admin/v1/properties/monthly-statement-management",
		monthlyStatementServicePeriodSampleXls:
			"/admin/v1/properties/monthly-statement-service-periods/sample-xls",
		monthlyStatementServicePeriods: (propertyId: string) =>
			`/admin/v1/properties/${propertyId}/monthly-statement-service-periods`,
		uploadMonthlyStatementServicePeriod: (
			propertyId: string,
			periodId: string,
		) =>
			`/admin/v1/properties/${propertyId}/monthly-statement-service-periods/${periodId}/upload`,
		monthlyStatementServicePeriodUnits: (
			propertyId: string,
			periodId: string,
		) =>
			`/admin/v1/properties/${propertyId}/monthly-statement-service-periods/${periodId}/units`,
		exportMonthlyStatementServicePeriodUnits: (
			propertyId: string,
			periodId: string,
		) =>
			`/admin/v1/properties/${propertyId}/monthly-statement-service-periods/${periodId}/units/export`,
		monthlyStatementUnitStatement: (
			propertyId: string,
			periodId: string,
			statementId: string,
		) =>
			`/admin/v1/properties/${propertyId}/monthly-statement-service-periods/${periodId}/statements/${statementId}`,
		exportMonthlyStatementUnitCsv: (
			propertyId: string,
			periodId: string,
			statementId: string,
		) =>
			`/admin/v1/properties/${propertyId}/monthly-statement-service-periods/${periodId}/statements/${statementId}/csv`,
		exportMonthlyStatementUnitPdf: (
			propertyId: string,
			periodId: string,
			statementId: string,
		) =>
			`/admin/v1/properties/${propertyId}/monthly-statement-service-periods/${periodId}/statements/${statementId}/pdf`,
	},
	propertyMarketing: {
		list: "/admin/v1/property-marketing",
		detail: (id: string) => `/admin/v1/property-marketing/${id}`,
		create: "/admin/v1/property-marketing/listings",
		archive: (id: string) => `/admin/v1/property-marketing/${id}/archive`,
		interestedUsers: (id: string) =>
			`/admin/v1/property-marketing/${id}/interested-users`,
	},
	phoUsers: {
		list: "/admin/v1/pho-users",
		detail: (id: string) => `/admin/v1/pho-users/${id}`,
		inviteAll: "/admin/v1/pho-users/invite-all",
		export: "/admin/v1/pho-users/export",
		invite: (id: string) => `/admin/v1/pho-users/${id}/invite`,
		block: (id: string) => `/admin/v1/pho-users/${id}/block`,
		unblock: (id: string) => `/admin/v1/pho-users/${id}/unblock`,
		associatedProperties: (id: string) =>
			`/admin/v1/pho-users/${id}/associated-properties`,
		documents: (id: string) => `/admin/v1/pho-users/${id}/documents`,
		documentDownloadLink: (customerId: string, documentId: string) =>
			`/admin/v1/pho-users/${customerId}/documents/${documentId}/download-link`,
		preStayReservations: (id: string) =>
			`/admin/v1/pho-users/${id}/pre-stay-reservations`,
		eventBookings: (id: string) => `/admin/v1/pho-users/${id}/event-bookings`,
		restaurantReservations: (id: string) =>
			`/admin/v1/pho-users/${id}/restaurant-reservations`,
	},
	roles: {
		list: "/admin/v1/roles",
		detail: (id: string) => `/admin/v1/roles/${id}`,
		modules: "/admin/v1/roles/modules",
		create: "/admin/v1/roles",
		update: (id: string) => `/admin/v1/roles/${id}`,
	},
	subAdmins: {
		list: "/admin/v1/admin-users",
		create: "/admin/v1/admin-users",
		detail: (id: string) => `/admin/v1/admin-users/${id}`,
		update: (id: string) => `/admin/v1/admin-users/${id}`,
		block: (id: string) => `/admin/v1/admin-users/${id}/block`,
		unblock: (id: string) => `/admin/v1/admin-users/${id}/unblock`,
		azureDirectoryUsers: "/admin/v1/admin-users/azure-directory-users",
	},
	upload: {
		signedUrl: "/upload/v1/media/signed-url",
	},
	fnbRestaurants: {
		list: "/admin/v1/fnb-restaurants",
		cuisines: "/admin/v1/fnb-restaurants/cuisines",
		create: "/admin/v1/fnb-restaurants",
		detail: (id: string) => `/admin/v1/fnb-restaurants/${id}`,
		update: (id: string) => `/admin/v1/fnb-restaurants/${id}`,
		publish: (id: string) => `/admin/v1/fnb-restaurants/${id}/publish`,
		deactivate: (id: string) => `/admin/v1/fnb-restaurants/${id}/deactivate`,
		activate: (id: string) => `/admin/v1/fnb-restaurants/${id}/activate`,
		delete: (id: string) => `/admin/v1/fnb-restaurants/${id}`,
	},
	beneficiaryApprovals: {
		list: "/admin/v1/beneficiary-approvals",
		detail: (id: string) => `/admin/v1/beneficiary-approvals/${id}`,
		approve: (id: string) => `/admin/v1/beneficiary-approvals/${id}/approve`,
		reject: (id: string) => `/admin/v1/beneficiary-approvals/${id}/reject`,
		propertyHistory: (propertyId: string) =>
			`/admin/v1/beneficiary-approvals/properties/${propertyId}/history`,
	},
	appUpdates: {
		list: "/admin/v1/app-updates",
		versions: "/admin/v1/app-updates/version",
	},
	staticContent: {
		list: "/admin/v1/static-content",
		byType: "/admin/v1/static-content",
		update: (id: string) => `/admin/v1/static-content/${id}`,
	},
} as const;
